import {HTMLProps} from "react";
import styled from "styled-components";

export const HorizontalNav = styled(function({children, ...props}: HTMLProps<HTMLElement>) {
    return <nav {...props}>
        <ul>{children}</ul>
    </nav>
})`
    > ul {
        list-style-type: none;
        padding: 0 .5rem;
        display: flex;
        flex-direction: row;
        gap: 1rem;
        margin: 0;
        align-items: stretch;
    }
`;
